export default __webpack_public_path__ + "static/media/organic.abe479cb.jpg";